<script>
	const utilities = require('utilities');
	const page = require('page');
	const model = require('model/model');

	module.exports = {
		props: {
			routeContext: {
				type: Object,
				required: true
			}
		},
		components: {
			modal: require('./modal.vue').default,
			'bookbag-icon': require('components/svg/bookbag-icon.vue').default,
			'teacher-icon': require('components/svg/teacher-icon.vue').default
		},
		data() {
			return {
				opts: null,
				remember: false
			};
		},
		mounted() {
			this.$subscribe('modal-closed', modalId => {
				if (modalId !== 'bifurcated-login-modal') {
					return;
				}
				this.opts = null;
			});

			this.$subscribe('modal-opened', (modalId, options) => {
				if (modalId !== 'bifurcated-login-modal') {
					return;
				}
				const loginChoice = model.get('loginChoice');
				if (loginChoice === 'teacher') {
					utilities.openModal('#teacher-login-modal');
				} else if (loginChoice === 'student') {
					page('/student-authentication');
					utilities.closeModals();
				}
			});
		},
		methods: {
			closeModal() {
				utilities.closeModals();
			},
			teacherChoiceClick() {
				if (this.remember) {
					model.set('loginChoice', 'teacher');
				}
				utilities.openModal('#teacher-login-modal');
			},
			studentChoiceClick() {
				if (this.remember) {
					model.set('loginChoice', 'student');
				}
				page('/student-authentication');
				this.closeModal();
			}
		},
		watch: {
			'routeContext.pathname': function () {
				if (document.location.hash.substring(1) === 'login-choice') {
					utilities.openModal('#bifurcated-login-modal');
					if (history && history.replaceState) {
						history.replaceState(undefined, undefined, '#');
					} else {
						document.location.hash = '#';
					}
				}
			}
		}
	};
</script>
<template>
	<modal
		ref="modal"
		id="bifurcated-login-modal"
		:ok="false"
		:wide="true">
		<template slot="header-container">
			<h2>Log in to ReadWorks!</h2>
			<p class="login-subheader">Which one are you?</p>
		</template>
		<template slot="content">
			<div class="bifurcation">
				<div class="flex-spacer">&nbsp;</div>
				<div class="choice-container">
					<button
						class="student-choice choice"
						@click="studentChoiceClick">
						<span class="choice-title">Student</span>
						<bookbag-icon></bookbag-icon>
					</button>
				</div>
				<div class="flex-spacer">&nbsp;</div>
				<div class="choice-container">
					<button
						class="teacher-choice choice"
						@click="teacherChoiceClick">
						<span class="choice-title">Educator/Parent</span>
						<teacher-icon></teacher-icon>
					</button>
				</div>
				<div class="flex-spacer">&nbsp;</div>
			</div>
			<div class="text-centered margin-top-medium form remember-form">
				<label class="input-wrapper">
					<input
						type="checkbox"
						v-model="remember" />
					Remember my selection
				</label>
			</div>
		</template>
	</modal>
</template>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	#bifurcated-login-modal {
		.modal-content-header {
			border-bottom: none;

			h2 {
			}

			.login-subheader {
				font-size: 1.25rem;
				color: $c-slate-dark;
				margin: 1rem 0 0 0;
			}
		}

		.bifurcation {
			display: flex;
			flex-direction: column;
			align-items: center;

			.choice-container {
				flex: 1;
				display: flex;
				flex-direction: column;
				justify-content: center;
				margin-top: 0.5rem;
				border-radius: 20px;
				width: 100%;
				max-width: 500px;
			}

			.choice {
				position: relative;
				overflow: hidden;
				display: flex;
				align-items: center;
				justify-content: center;
				height: 7rem;
				// width: 352px;
				width: 100%;
				border-radius: 20px;
				border: none;
				text-align: center;
				font-size: 2rem;
				font-weight: bold;
				color: $c-white;

				svg {
					position: absolute;
					z-index: 3;
					top: -20px;
					height: 171px;
					width: 100px;
				}

				.choice-title {
					position: relative;
					z-index: 5;
					margin-bottom: 0.5rem;
				}

				&.student-choice {
					background-color: $c-green-main;

					svg {
						left: 0.5rem;
					}
				}

				&.teacher-choice {
					background-color: $c-grape-main;

					svg {
						right: 0.5rem;
					}
				}

				&:hover {
					box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.5);
				}
			}

			.flex-spacer {
				flex: 1;
			}
		}

		.remember-form {
			label {
				display: flex;
				justify-content: center;
				align-items: center;
			}
		}
	}

	@media only screen and (min-width: $bp-width-med) {
		#bifurcated-login-modal {
			.bifurcation {
				flex-direction: row;

				.choice-container {
					justify-content: center;
					align-items: center;
					max-width: 352px;
					flex-basis: 352px;
				}

				.choice {
					position: relative;
					overflow: hidden;
					display: inline-flex;
					justify-content: center;
					align-items: baseline;
					height: 25rem;

					svg {
						top: -50px;
						left: 0;
						right: 0;
						height: 600px;
						width: 352px;
						margin-left: auto;
						margin-right: auto;
					}

					.choice-title {
						margin-top: 0.5rem;
						display: flex;
						flex-direction: column;
						justify-content: center;
					}
				}
			}
		}
	}
</style>
